export const zh = {
  common: {
    loading: '加载中...',
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    connectWallet: '请先连接钱包',
    userCancelled: '用户取消了操作',
    paymentFailed: '支付失败',
    uploadFailed: '上传失败，请重试',
    uploading: '上传中...',
    uploaded: '✓ 图标已上传',
    waitingUpload: '等待上传...',
    connectWalletToUpload: '请连接钱包后自动上传',
    selectImage: '点击选择图标（最大 5MB）',
    selectImageFile: '请选择图片文件',
    fileTooLarge: '文件大小不能超过 5MB',
    transactionSent: '交易已发送，等待确认...',
    paymentConfirmed: '支付已确认',
    paymentSuccess: '支付成功！',
    deployed: '已部署',
    submitted: '已提交',
    sendingTransaction: '发送交易...',
    waitingConfirmation: '等待确认...',
    viewOnChain: '查看链上信息',
    viewContract: '查看合约',
    visit: '访问',
    beFirstSubmitter: '成为第一个提交者',
  },
  nav: {
    home: '首页概览',
    deployToken: '一键发币',
    dappEntry: 'DApp 入驻',
    tokenList: '代币收录',
    admin: '管理后台',
    contact: '联系我们',
    connectWallet: '连接钱包',
  },
  contact: {
    title: '联系我们',
    description: '如有任何问题或合作意向，欢迎随时与我们联系',
    emailLabel: '官方邮箱',
    responseTime: '我们会在 24 小时内回复您的邮件',
    sendEmail: '发送邮件',
  },
  home: {
    title: 'MaToken Web3 钱包服务',
    titlePrefix: '下一代',
    multiChainSupport: '支持多链生态',
    subtitle: '安全、便捷的去中心化数字钱包，支持多链资产管理，让您的加密资产安全无忧',
    coreFeatures: '核心功能',
    coreFeaturesDesc: '为您提供安全、便捷的数字资产管理体验',
    secureStorage: '安全存储',
    secureStorageDesc: '本地加密私钥',
    multiChain: '多链支持',
    multiChainDesc: '支持主流公链',
    easyUse: '便捷操作',
    easyUseDesc: '简洁直观界面',
    dappBrowser: 'DApp浏览',
    dappBrowserDesc: '内置Web3浏览器',
    downloadNow: '立即下载',
    downloadDesc: '选择您的平台，开始使用 MaToken 钱包',
    iosVersion: 'iOS 版本',
    iosDesc: '通过 TestFlight 安装测试版',
    testflightDownload: 'TestFlight 下载',
    androidVersion: 'Android 版本',
    androidDesc: '支持 Android 6.0 及以上版本',
    apkDownload: 'APK 直接下载',
    scanToDownload: '扫码下载',
    versionInfo: '版本信息',
    currentVersion: '当前版本:',
    platform: '平台:',
    updateTime: '更新时间:',
    fileSize: '文件大小:',
    installGuide: '安装指南',
    iosInstall: 'iOS 安装步骤',
    androidInstall: 'Android 安装步骤',
    iosStep1: '点击下载按钮，跳转至 TestFlight',
    iosStep2: '如未安装 TestFlight，先从 App Store 下载',
    iosStep3: '在 TestFlight 中点击"接受"并安装',
    androidStep1: '点击下载 APK 文件',
    androidStep2: '打开文件，允许"未知来源"安装',
    androidStep3: '点击"安装"完成安装',
    supportedChains: '支持的公链',
    web3Services: 'Web3 服务',
    web3ServicesDesc: '自动化 Web3 服务平台，收录的代币和 DApp 将直接展示在 MaToken 钱包中',
    deployToken: '一键发币',
    deployTokenDesc: '基于工厂合约的一键式代币部署，快速创建您的 ERC20 代币',
    dappEntry: 'DApp 入驻',
    dappEntryDesc: '提交您的 DApp，让更多用户发现和使用',
    tokenList: '代币收录',
    tokenListDesc: '将您的代币收录到平台，提升曝光度',
    oneToken: '1 代币',
    deployedTokens: '已部署代币',
    deployedTokensDesc: '通过平台部署的代币总数',
    dappCount: 'DApp 数量',
    dappCountDesc: '提交到平台的 DApp 总数',
    listedTokens: '代币收录',
    listedTokensDesc: '收录到平台的代币总数',
    comingSoon: '即将上线',
    noApkAvailable: '暂无可用版本',
  },
  deployToken: {
    title: '一键发币',
    description: '基于工厂合约快速部署 ERC20 代币，快速创建您的专属代币',
    tokenInfo: '代币信息',
    tokenInfoDesc: '填写代币基本信息',
    selectChain: '选择链',
    chainHint: '支持以太坊主网和 Sepolia 测试网',
    ethereumMainnet: '以太坊主网',
    ethereumSepolia: '以太坊 Sepolia (测试网)',
    tokenLogo: '代币图标',
    tokenName: '代币名称',
    tokenNamePlaceholder: '例如: My Token',
    tokenSymbol: '代币符号',
    tokenSymbolPlaceholder: '例如: MTK',
    tokenSymbolHint: '建议使用 3-6 个大写字母',
    totalSupply: '总供应量',
    totalSupplyPlaceholder: '1000000',
    totalSupplyHint: '代币总供应量（18 位小数）',
    feeInfo: '费用说明',
    deployFee: '部署费用',
    feeDesc: '费用将在部署时自动扣除，部署成功后您将获得代币合约的所有权。',
    notes: '注意事项',
    note1: '代币符号一旦部署不可更改',
    note2: '总供应量建议根据实际需求设置',
    note3: '部署后请妥善保管合约地址',
    payAndDeploy: '支付 {amount} 代币并部署',
    deployHint: '点击按钮将先完成登录，然后进行支付和部署，部署成功后会自动索引到平台',
    deployConfirmed: '部署已确认，正在索引代币...',
    deploySuccess: '代币部署成功！',
    tokenAddress: '代币地址',
    switchNetwork: '请切换到 {network} 网络',
    fillAllFields: '请填写所有字段',
  },
  dapp: {
    listTitle: 'DApp 列表',
    listDesc: '发现和探索优秀的去中心化应用',
    submitDapp: '提交 DApp',
    noDapps: '暂无 DApp',
    createTitle: 'DApp 入驻',
    createDesc: '提交您的 DApp 到平台，让更多用户发现和使用',
    dappInfo: 'DApp 信息',
    dappInfoDesc: '填写您的 DApp 基本信息',
    dappName: 'DApp 名称',
    dappNamePlaceholder: '例如: My DApp',
    dappDescription: '描述',
    dappDescriptionPlaceholder: '简要描述您的 DApp 功能和特点...',
    dappUrl: 'URL',
    dappUrlPlaceholder: 'https://example.com',
    dappCategory: '分类',
    dappCategoryPlaceholder: 'DeFi, NFT, GameFi, Social 等',
    dappLogo: 'DApp 图标',
    payAndSubmit: '支付并提交',
    payAndSubmitBtn: '支付 {amount} 代币并提交',
    submitHint: '点击按钮将同时完成支付和提交，支付成功后会自动提交 DApp',
    submittingDapp: '支付已确认，正在提交 DApp...',
    submitSuccess: '支付成功！DApp 已提交，等待管理员审核。',
    feeInfo: '费用说明',
    listingFee: '入驻费用',
    feeDesc: '提交后需要管理员审核，审核通过后您的 DApp 将显示在平台上。',
    notes: '注意事项',
    note1: '请确保 URL 可正常访问',
    note2: '分类选择要准确，便于用户查找',
    note3: '提交后可在 DApp 列表查看审核状态',
    fillRequired: '请填写必填字段',
  },
  token: {
    listTitle: '代币列表',
    listDesc: '查看所有已部署和收录的代币',
    listToken: '收录代币',
    listedTokens: '已收录代币',
    deployedTokens: '已部署代币',
    noListedTokens: '暂无收录的代币',
    noDeployedTokens: '暂无部署的代币',
    chainId: '链 ID',
    contractAddress: '合约地址',
    deployTime: '部署时间',
    createTitle: '代币收录',
    createDesc: '将您的代币收录到平台，提升曝光度和知名度',
    tokenInfo: '代币信息',
    tokenInfoDesc: '填写代币合约地址',
    tokenLogo: '代币图标',
    tokenAddress: '代币合约地址',
    tokenAddressPlaceholder: '0x...',
    payAndSubmit: '支付并提交',
    payAndSubmitBtn: '支付 {amount} 代币并提交',
    submitHint: '点击按钮将同时完成支付和提交，支付成功后会自动提交代币收录',
    submittingToken: '支付已确认，正在提交代币收录...',
    submitSuccess: '支付成功！代币已收录。',
    feeInfo: '费用说明',
    listingFee: '收录费用',
    feeDesc: '收录后您的代币将显示在平台代币列表中，用户可以查看和交易。',
    notes: '注意事项',
    note1: '请确保合约地址正确且为 ERC20 代币',
    note2: '代币必须已部署在支持的链上',
    note3: '收录后可在代币列表查看',
    fillTokenAddress: '请填写代币合约地址',
    txHash: '交易哈希',
    paymentReceiver: '支付接收地址',
  },
  errors: {
    loginFailed: '登录失败，无法获取 JWT token',
    chainNotSupported: '当前链不支持该代币，请切换到 Sepolia 测试网',
    paymentReceiverNotConfigured: '支付接收地址未配置，请联系管理员',
    walletNotConnected: '钱包未连接，请先连接钱包',
    transactionInProgress: '已有交易正在处理中，请等待...',
    switchToChain: '请切换到链 ID {chainId} 的网络',
    manualSwitchChain: '请手动切换到目标链',
  },
};

export type TranslationKeys = typeof zh;
